export interface IEnvVars {
  VERSION: string;
  DOWNLOAD_URL: string;
  GRAPHQL_API_URL: string;
  METRICS_API_URL: string;
  CHARTS_API_URL: string;
}

export const envVars: IEnvVars = (window as any).__env__;
